import Event from '../Event.js';

export default class Unstructured extends Event {
  _pushEventData(...args) {
    super._pushEventData('trackSelfDescribingEvent');
    this.event.push(...args);
  }
}
